import React from "react";
import { Heading, Center } from "@chakra-ui/react";

export const About = () => {
  return (
    <div className="heading" id="about" >
      <div className="container-fluid" >
        <Center>
          <Heading >
            All <span style={{ color: "rgb(220, 20, 60)" }}> About Me</span>
          </Heading>
        </Center>

        <div className="row">
          <div className="col d-none d-xl-block d-xxl-none">
            <img
              src="https://technext.github.io/patrix/images/services/service-2.png"
              className="rounded float-end"
              alt="..."
            />
          </div>
          <div className="col px-5">
            <ul>
              <li className="mt-5 fw-normal fs-6 ">
                Hello! My name is Rohaan Telangur and I enjoy creating things
                that live on the internet.
              </li>
              <li className="mt-3 fw-normal fs-6">
                I'm a passionate Developer, with strong administrative and
                communication skills, good attention to detail and the ability
                to write efficient code using MERN Stack.
              </li>
              <li className="mt-3 fw-normal fs-6">
                My interest in web development started back last year when I was
                trying to edit things on the web, that taught me a lot about
                HTML & CSS.
              </li>
              <li className="mt-3 fw-normal fs-6">
                As I grow and flourish as a Developer, one thing which keeps me
                going is my inquisitiveness for discovering new things every
                day.
              </li>
              <li className="mt-3 fw-normal fs-6">
                Fast Forwarding to today, I built a number of web applications
                and 4 major projects. Learned a great deal about teamwork,
                leadership, and communication. After months of rigorous
                training, here I am looking for an opportunity as a full stack
                web developer.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
